import { createTheme } from '@mui/material/styles';
import {
  AIADMIN_FONT_FAMILY,
  AIADMIN_PRIMARY_COLOR,
  AIADMIN_TEXT_PRIMARY,
  AIADMIN_TEXT_SECONDARY
} from './common/styles/aiadminThemeTokens';

export {
  AIADMIN_PRIMARY_COLOR,
  AIADMIN_PRIMARY_HOVER_COLOR,
  AIADMIN_TEXT_PRIMARY,
  AIADMIN_TEXT_SECONDARY,
  AIADMIN_SECONDARY_TEXT_COLOR,
  AIADMIN_MUTED_TEXT_COLOR,
  AIADMIN_ON_PRIMARY_MUTED_TEXT_COLOR,
  AIADMIN_ON_PRIMARY_SUBTLE_TEXT_COLOR,
  AIADMIN_ON_PRIMARY_BORDER_COLOR,
  AIADMIN_SURFACE_WHITE_HEX_COLOR,
  AIADMIN_SURFACE_HOVER_COLOR,
  AIADMIN_SURFACE_HOVER_LIGHT_COLOR,
  AIADMIN_BORDER_DEFAULT_COLOR,
  AIADMIN_TRENDS_BORDER_SUBTLE_COLOR,
  AIADMIN_TRENDS_BORDER_SUBTLE_FAINT_COLOR,
  AIADMIN_TRENDS_FORM_SURFACE_COLOR,
  AIADMIN_TRENDS_MUTED_TEXT_COLOR,
  AIADMIN_TRENDS_TOGGLE_BG_COLOR,
  AIADMIN_TRENDS_TOGGLE_HOVER_COLOR,
  AIADMIN_TRENDS_KPI_ACTIVE_SHADOW_COLOR,
  AIADMIN_TRENDS_KPI_HOVER_SHADOW_COLOR,
  AIADMIN_REPORT_PANEL_BORDER_COLOR,
  AIADMIN_OVERLAY_ON_PRIMARY_HOVER_COLOR,
  AIADMIN_CHART_TEAL_PRIMARY_COLOR,
  AIADMIN_CHART_TEAL_SECONDARY_COLOR,
  AIADMIN_CHART_TEAL_TERTIARY_COLOR,
  AIADMIN_CHART_TEAL_LIGHT_COLOR,
  AIADMIN_CHART_TEAL_DEEP_COLOR,
  AIADMIN_CHART_TEAL_SLATE_COLOR,
  AIADMIN_CHART_TEAL_MUTED_COLOR,
  AIADMIN_CHART_TEAL_DARK_COLOR,
  AIADMIN_CHART_DISLIKE_COLOR,
  AIADMIN_CHART_NEUTRAL_GRAY_COLOR,
  AIADMIN_CHART_MUTED_RED_COLOR,
  AIADMIN_TRENDS_COUNT_CHART_COLORS,
  AIADMIN_TREND_LINE_FEATURE_COLORS,
  AIADMIN_TREND_LINE_FALLBACK_COLORS,
  AIADMIN_TRENDS_FONT_FAMILY,
  AIADMIN_SURFACE_HOVER_STRONG_COLOR,
  AIADMIN_CONTROL_OUTLINE_COLOR,
  AIADMIN_PRIMARY_HALO_COLOR,
  AIADMIN_PRIMARY_HOVER_STRONG_COLOR,
  AIADMIN_SECONDARY_BUTTON_TEXT_COLOR,
  AIADMIN_FONT_FAMILY
} from './common/styles/aiadminThemeTokens';
// import * as constants from '../../common/constants';

export const AIADMIN_PRIMARY = AIADMIN_PRIMARY_COLOR;
export const AIADMIN_SECONDARY = AIADMIN_PRIMARY_COLOR;
export const AIADMIN_BACKGROUND = AIADMIN_PRIMARY_COLOR;
export const AIADMIN_DISABLED = '#c7c7c7';
export const AIADMIN_BORDER = AIADMIN_PRIMARY_COLOR;
export const DRAWER_HOVER = AIADMIN_PRIMARY_COLOR;

// Theme colors in HSL format
// Surface colors
export const AIADMIN_SURFACE_WHITE_COLOR = 'hsl(0, 0%, 100%)';
export const AIADMIN_SURFACE_MUTED_COLOR = 'hsl(0, 0%, 98%)';
export const AIADMIN_SURFACE_SUBTLE_COLOR = 'hsl(210, 20%, 97%)';
export const AIADMIN_SURFACE_SUBTLE_ALT_COLOR = 'hsl(210, 20%, 98%)';
export const AIADMIN_SURFACE_PAGE_COLOR = 'hsl(0, 0%, 96%)';

// Border colors
export const AIADMIN_BORDER_LIGHT_COLOR = 'hsl(214, 20%, 93%)';
export const AIADMIN_BORDER_MEDIUM_COLOR = 'hsl(214, 20%, 85%)';
export const AIADMIN_BORDER_DARK_COLOR = 'hsl(214, 20%, 25%)';
export const AIADMIN_BORDER_BAR_FAILED_COLOR = 'hsl(214, 15%, 80%)';

// Fill colors
export const AIADMIN_BAR_FAILED_FILL_COLOR = 'hsl(214, 20%, 88%)';

// Text colors
export const AIADMIN_HEADING_TEXT_COLOR = 'hsl(210, 20%, 12%)';
export const AIADMIN_SUBHEADING_TEXT_COLOR = 'hsl(215, 25%, 20%)';
export const AIADMIN_EMPHASIS_TEXT_COLOR = 'hsl(215, 20%, 30%)';
export const AIADMIN_AXIS_LABEL_TEXT_COLOR = 'hsl(215, 14%, 40%)';
export const AIADMIN_BAR_PERCENT_TEXT_COLOR = 'hsl(215, 16%, 30%)';
export const AIADMIN_BAR_PERCENT_MUTED_TEXT_COLOR = 'hsl(215, 10%, 62%)';
export const AIADMIN_ACCENT_TEXT_COLOR = 'hsl(196, 100%, 26%)';
export const AIADMIN_BLOCK_TITLE_TEXT_COLOR = 'hsl(187, 94%, 35%)';

// Overlay colors
export const AIADMIN_OVERLAY_SCRIM_COLOR = 'hsla(215, 25%, 20%, 0.35)';
export const AIADMIN_LOADER_OVERLAY_BACKGROUND_COLOR = 'hsla(0, 0%, 100%, 0.75)';
export const AIADMIN_PRIMARY_SUBTLE_HOVER_BACKGROUND_COLOR = 'hsla(215, 25%, 20%, 0.1)';

// Chart colors
export const AIADMIN_CHART_BAR_GRADIENT_END_COLOR = 'hsl(207, 90%, 72%)';
export const AIADMIN_CHART_FOCUS_RING_COLOR = 'hsl(207, 90%, 68%)';

// Status colors
export const AIADMIN_STATUS_GOOD_BACKGROUND_COLOR = 'hsl(152, 76%, 90%)';
export const AIADMIN_STATUS_GOOD_TEXT_COLOR = 'hsl(164, 86%, 16%)';
export const AIADMIN_STATUS_GOOD_BORDER_COLOR = 'hsl(152, 50%, 80%)';
export const AIADMIN_STATUS_MIXED_BACKGROUND_COLOR = 'hsl(48, 96%, 89%)';
export const AIADMIN_STATUS_MIXED_TEXT_COLOR = 'hsl(22, 78%, 26%)';
export const AIADMIN_STATUS_MIXED_BORDER_COLOR = 'hsl(48, 70%, 75%)';
export const AIADMIN_STATUS_LOW_BACKGROUND_COLOR = 'hsl(356, 100%, 95%)';
export const AIADMIN_STATUS_LOW_TEXT_COLOR = 'hsl(347, 77%, 35%)';
export const AIADMIN_STATUS_LOW_BORDER_COLOR = 'hsl(356, 70%, 85%)';

// Mid-tone fills for charts and distribution bars (between border and text)
export const AIADMIN_STATUS_GOOD_MID_COLOR = 'hsl(155, 62%, 42%)';
export const AIADMIN_STATUS_MIXED_MID_COLOR = 'hsl(42, 82%, 56%)';
export const AIADMIN_STATUS_LOW_MID_COLOR = 'hsl(0, 65%, 45%)';

// Tier chip colors
export const AIADMIN_TIER_GOOD_BACKGROUND_COLOR = 'hsl(145, 63%, 90%)';
export const AIADMIN_TIER_GOOD_TEXT_COLOR = 'hsl(152, 82%, 22%)';
export const AIADMIN_TIER_MIXED_BACKGROUND_COLOR = 'hsl(42, 87%, 90%)';
export const AIADMIN_TIER_MIXED_TEXT_COLOR = 'hsl(32, 78%, 28%)';
export const AIADMIN_TIER_LOW_BACKGROUND_COLOR = 'hsl(0, 73%, 93%)';
export const AIADMIN_TIER_LOW_TEXT_COLOR = 'hsl(0, 63%, 33%)';

// Shadow colors — base tint triplet for hsla(); composed shadows derive from this
export const AIADMIN_SHADOW_COLOR = '210, 20%, 10%';
export const AIADMIN_SHADOW_SOFT = `0 1px 3px hsla(${AIADMIN_SHADOW_COLOR}, 0.08)`;
export const AIADMIN_SHADOW_ELEVATED = `0 1px 3px hsla(${AIADMIN_SHADOW_COLOR}, 0.2)`;
export const AIADMIN_SHADOW_PANEL = `0 8px 32px hsla(${AIADMIN_SHADOW_COLOR}, 0.2)`;
export const AIADMIN_SHADOW_BLOCK = `0 1px 2px hsla(${AIADMIN_SHADOW_COLOR}, 0.04)`;
export const AIADMIN_SHADOW_BAR = `0 1px 2px hsla(${AIADMIN_SHADOW_COLOR}, 0.08)`;
export const AIADMIN_SHADOW_BAR_INSET = `inset 0 0 0 1px hsla(${AIADMIN_SHADOW_COLOR}, 0.05)`;
export const AIADMIN_SHADOW_RUBRIC = `0 1px 3px hsla(${AIADMIN_SHADOW_COLOR}, 0.06)`;

export const aiadminInsetBorderShadow = (borderColor) => `inset 0 0 0 1px ${borderColor}`;

// Common settings shared by both light and dark themes
const commonThemeSettings = {
  typography: {
    fontFamily: AIADMIN_FONT_FAMILY,
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '0.5px'
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
      letterSpacing: '0.4px'
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 500,
      lineHeight: 1.4,
      letterSpacing: '0.3px'
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.5,
      letterSpacing: '0.2px'
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.1px',
      color: AIADMIN_TEXT_PRIMARY
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: 1.6,
      letterSpacing: '0.1px',
      color: AIADMIN_TEXT_PRIMARY
    },
    body1: {
      fontSize: '1rem',
      color: AIADMIN_TEXT_PRIMARY
    },
    body2: {
      fontSize: '0.875rem',
      color: AIADMIN_TEXT_PRIMARY,
      textAlign: 'left'
    },
    button: {
      textTransform: 'uppercase' // Uppercase text for buttons
    }
  },
  spacing: 8, // Base spacing unit
  shape: {
    borderRadius: 8 // Global border-radius for rounded corners
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
    modal: 1300
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)'
    },
    duration: {
      standard: 300,
      short: 150,
      long: 600
    }
  },

  // Default border settings (color and width)
  border: {
    color: AIADMIN_PRIMARY, // Default border color
    width: '2px', // Default border width
    radius: '8px' // Default border radius
  },

  // Button, Input, Dropdown, Radio Button, and Border Styling
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 12, // All buttons will have rounded corners
        borderWidth: '2px', // Button border width
        borderColor: '#1976d2', // Border color for outlined buttons
        color: `${AIADMIN_TEXT_SECONDARY} !important`
      },
      disabled: {
        backgroundColor: '#dcdcdc !important', // Set your desired background color
        color: '#999', // Set your desired text color
        cursor: 'not-allowed !important'
      },
      contained: {
        color: `${AIADMIN_TEXT_SECONDARY} !important`,
        padding: '8px 16px !important',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' // Custom button shadow for light theme
      },
      outlined: {
        borderWidth: '2px', // Border width for outlined buttons
        borderColor: '#1976d2', // Border color for outlined buttons
        '&:hover': {
          borderColor: '#115293' // Darker border color on hover
        }
      },
      text: {
        padding: '8px 16px' // Padding for text buttons
      }
    },
    // Input Box (TextField / OutlinedInput) Styles
    MuiTextField: {
      root: {
        marginBottom: '16px' // Space below input fields
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '12px', // Rounded corners for outlined input fields
        borderWidth: '2px', // Border width
        borderColor: '#1976d2', // Default border color
        '&.Mui-focused': {
          borderColor: '#1976d2' // Border color when focused
        },
        '&:hover': {
          borderColor: '#115293' // Darker border color on hover
        }
      },
      input: {
        padding: '12px 16px', // Padding inside the input box
        fontSize: '1rem', // Font size for the input text
        color: AIADMIN_TEXT_PRIMARY // Text color inside the input box
      }
    },
    MuiInputLabel: {
      root: {
        color: '#555', // Label color in the light theme
        '&.Mui-focused': {
          color: '#1976d2' // Label color when focused
        }
      }
    },

    MuiSelect: {
      root: {
        borderRadius: '12px', // Ensure consistent rounded corners
        border: '2px solid #ccc', // Default border
        '&:hover': {
          borderColor: '#1976d2' // Hover state color
        },
        '&.Mui-focused': {
          borderColor: '#1976d2' // Focus state color
        }
      },
      select: {
        padding: '12px', // Ensure proper padding inside the select field
        borderRadius: '12px'
      },
      icon: {
        color: '#1976d2' // Dropdown arrow color
      }
    },

    // Radio Button Styles
    MuiRadio: {
      root: {
        color: '#1976d2', // Default radio button color
        '&.Mui-checked': {
          color: '#1976d2' // Color when checked
        },
        '&:hover': {
          backgroundColor: 'rgba(25, 118, 210, 0.04)' // Hover effect (light blue background on hover)
        },
        '&:focus': {
          backgroundColor: 'transparent' // Remove focus outline background
        },
        borderWidth: '2px', // Border width for radio buttons
        borderColor: '#1976d2' // Border color for radio buttons
      }
    },

    MuiFormControlLabel: {
      label: {
        fontSize: '1rem', // Font size for label
        color: AIADMIN_TEXT_PRIMARY, // Default color for label
        '&.Mui-checked': {
          color: '#1976d2' // Label color when radio button is selected
        }
      }
    },

    // Card and Paper Components - Global Border Styles
    MuiCard: {
      root: {
        borderWidth: '2px', // Border width for cards
        borderColor: '#1976d2', // Border color for cards
        borderRadius: '8px', // Rounded corners for cards
        boxShadow: 'none' // Optional: Set no box shadow (or add your own)
      }
    },
    MuiPaper: {
      root: {
        borderWidth: '2px', // Border width for paper components (like Dialogs, Containers, etc.)
        borderColor: '#1976d2', // Border color for paper components
        borderRadius: '8px' // Rounded corners for paper components
      }
    }
  }
};

export const getDarkTheme = () => {
  return createTheme({
    ...commonThemeSettings, // Spread the common settings
    colors: {
      background: {
        hover: '#000'
      }
    },
    palette: {
      mode: 'dark', // Theme mode: 'light' or 'dark'
      primary: {
        main: AIADMIN_PRIMARY, // Primary color (light blue)
        contrastText: '#000' // Text color for primary elements (black)
      },
      secondary: {
        main: AIADMIN_TEXT_SECONDARY,
        contrastText: '#000' // Text color for secondary elements (black)
      },
      background: {
        default: '#121212', // Default background color for the app
        paper: AIADMIN_TEXT_SECONDARY, // Background color for paper components //#1d1d1d
        darkGray: AIADMIN_TEXT_PRIMARY, // Custom background color (dark gray)
        darkBlue: AIADMIN_PRIMARY, // Custom background color (dark blue) //#263238
        accent: '#3e2723' // Custom accent background (brownish)
      },
      border: {
        darkBlue: AIADMIN_PRIMARY
      },
      text: {
        primary: AIADMIN_TEXT_SECONDARY, // Primary text color
        secondary: '#b0bec5' // Secondary text color
      },
      action: {
        active: '#90caf9', // Active state color for actions like icons
        hover: AIADMIN_PRIMARY, // Hover state color
        selected: '#90caf9' // Selected state color
      }
    },
    // shadows: [
    //   'none',
    //   '0px 2px 10px rgba(0, 0, 0, 0.2)',
    //   '0px 4px 20px rgba(0, 0, 0, 0.3)',
    //   '0px 6px 30px rgba(0, 0, 0, 0.4)'
    // ],
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-input': {
              color: AIADMIN_TEXT_PRIMARY // Default text color inside the TextField
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: AIADMIN_PRIMARY // Default border color
              },
              '&.Mui-disabled': {
                color: `${AIADMIN_DISABLED} !important`, // Make text visible
                '-webkit-text-fill-color': `${AIADMIN_DISABLED} !important`, // Override for Webkit browsers
                opacity: 1, // Ensure full opacity,
                border: '1px solid #000'
              },
              '&:hover fieldset': {
                borderColor: AIADMIN_PRIMARY // Hover border color
              },
              '&.Mui-focused fieldset': {
                borderColor: AIADMIN_PRIMARY // Focus border color
              },
              border: `1px solid ${AIADMIN_DISABLED}`
            }
          }
        }
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            // Override the default background color for the root of the Autocomplete
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: AIADMIN_PRIMARY
            },
            '& .MuiOutlinedInput-root': {
              '& .MuiInputBase-input': {
                color: AIADMIN_TEXT_PRIMARY // Custom text color for the input text
              },
              '& .MuiIconButton-root': {
                color: AIADMIN_TEXT_PRIMARY // Custom text color for the input text
              }
            }
          },
          listbox: {
            '& .MuiAutocomplete-option': {
              '&:hover': {
                backgroundColor: AIADMIN_PRIMARY, // Background color on hover in the dropdown
                color: AIADMIN_TEXT_SECONDARY // Text color on hover in the dropdown
              },
              '&.Mui-focused': {
                backgroundColor: AIADMIN_PRIMARY, // Focused state background color for the option
                color: AIADMIN_TEXT_SECONDARY // Focused option text color
              }
            }
          }
        }
      },
      // Style overrides for ListItem (Drawer and other lists)
      MuiListItem: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: '#1a2029', // Hover background color
              color: AIADMIN_TEXT_SECONDARY // Hover text color
            }
          }
        }
      },
      // Style overrides for Drawer menu ListItems
      MuiListItemText: {
        styleOverrides: {
          primary: {
            '&:hover': {
              color: AIADMIN_TEXT_SECONDARY // Ensure text changes to white on hover
            }
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: AIADMIN_PRIMARY, // Background color on hover
              color: AIADMIN_TEXT_SECONDARY // Text color on hover
            }
          }
        }
      },
      // MuiMenu: {
      //   styleOverrides: {
      //     paper: {
      //       marginTop: '10px' // Add vertical spacing globally
      //     }
      //   },
      //   defaultProps: {
      //     anchorOrigin: {
      //       vertical: 'bottom',
      //       horizontal: 'left'
      //     },
      //     transformOrigin: {
      //       vertical: 'top',
      //       horizontal: 'left'
      //     },
      //     getContentAnchorEl: null // Default to better positioning
      //   }
      // },
      // MuiPopover: {
      //   defaultProps: {
      //     anchorOrigin: {
      //       vertical: 'bottom',
      //       horizontal: 'left'
      //     },
      //     transformOrigin: {
      //       vertical: 'top',
      //       horizontal: 'left'
      //     }
      //   }
      // },
      MuiSelect: {
        styleOverrides: {
          root: {
            // backgroundColor: 'lightblue', // Change background color of the select box
            borderRadius: '4px', // Round the corners of the select box
            color: '#000',
            // border: '1px solid #8a8a8a',
            // padding: '8px 16px', // Padding inside the select box
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: AIADMIN_PRIMARY // Default border color
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: AIADMIN_PRIMARY // Hover border color
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: AIADMIN_PRIMARY // Focused border color
            },
            '&.Mui-disabled': {
              color: `${AIADMIN_DISABLED} !important`,
              '-webkit-text-fill-color': `${AIADMIN_DISABLED} !important`,
              opacity: 1,
              borderColor: '1px solid #000'
            }
          },
          select: {
            '&.Mui-disabled': {
              color: `${AIADMIN_DISABLED} !important`, // Visible text
              '-webkit-text-fill-color': `${AIADMIN_DISABLED} !important`
            }
          },
          icon: {
            color: '#000000',
            justifyContent: 'center',
            '&.Mui-disabled': {
              color: AIADMIN_DISABLED
            } // Change color of the dropdown icon (arrow)
          },
          outlined: {
            // border: '1px solid #c7c7c7' // Border style for outlined variant
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: AIADMIN_TEXT_SECONDARY,
            borderRadius: '12px',
            padding: '8px 16px',
            backgroundColor: AIADMIN_BACKGROUND,
            '&:hover': {
              backgroundColor: AIADMIN_BACKGROUND,
              transform: 'scale(1.05)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.7)'
            },
            '&:hover::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: '12px', // Same as the Button's borderRadius
              padding: '2px', // Thickness of the outline
              background: 'linear-gradient(135deg, #E49D2D 0%, #EA0B7E 51.09%, #851B4A 100%)',
              WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude',
              pointerEvents: 'none',
              zIndex: 0
            },
            '&.Mui-disabled': {
              backgroundColor: '#8e9294',
              // backgroundColor: '#b0bec5'
              // color: '#607d8b'
              color: '#ffffff'
            }
          },
          // disabled: {
          //   backgroundColor: '#b0bec5',
          //   color: '#607d8b'
          // },
          sizeSmall: {
            '& span': {
              minWidth: 'auto'
            }
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: AIADMIN_TEXT_SECONDARY
          }
        }
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            color: AIADMIN_TEXT_PRIMARY
          }
        }
      },
      // Override TableCell
      MuiTableCell: {
        styleOverrides: {
          root: {
            color: AIADMIN_TEXT_PRIMARY
            // padding: '8px'
          }
        }
      },
      // Override TableHeader
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: AIADMIN_PRIMARY
          }
        }
      },
      MuiTableSortLabel: {
        styleOverrides: {
          root: {
            color: AIADMIN_TEXT_SECONDARY // White color for sort label in header
          }
        }
      },
      // Override TablePagination
      MuiTablePagination: {
        styleOverrides: {
          root: {
            backgroundColor: '#f1f1f1', // Custom background color for pagination area
            color: AIADMIN_TEXT_PRIMARY, // Custom text color for pagination
            borderTop: `2px solid ${AIADMIN_BORDER}`, // Border for pagination
            borderBottomRightRadius: '8px',
            borderBottomLeftRadius: '8px'
          },
          select: {
            color: AIADMIN_TEXT_PRIMARY // Color for rows per page select dropdown
          },
          actions: {
            color: AIADMIN_TEXT_SECONDARY
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          root: {
            backgroundColor: '#5c687d',
            '&:hover': {
              backgroundColor: '#5c687d'
            }
          }
        }
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            margin: 'auto'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: '#6a7070'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ccc'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1976d2'
          }
        }
      }
    }
  });
};

export const commonStyleProps = () => {
  return createTheme({
    palette: {
      styleFlex: 'flex',
      styleInline: 'inline',
      style10px: '10px',
      style5px: '5px',
      style2px: '2px',
      style2pxSolidBlack: '2px solid black',
      style100Percentage: '100%',
      styleCenter: 'center',
      style25px: '25px',
      style50px: '50px',
      style40px: '40px',
      style20px: '20px',
      styleWhiteColor: 'white',
      styleBlackColor: 'black',
      style35Percentage: '35%',
      style65Percentage: '65%',
      style300px: '300px',
      styleBorderGray: '1px solid #e0e0e0',
      style20pxPadding: '20px'
    }
  });
};
